import { TGetEnumOptionReqDto, TGetEnumOptionsResDto } from "@/api/services/global/enum/dtos/get-enum-options.dto";
import { CACHED_TIME } from "@/constants/common";
import { QUERY_KEYS } from "@/constants/queryKeys";
import { valueOf } from "@/types/common";
import { globalApi } from "@/utils/api";
import { createUrlWithParams } from "@/utils/url";
import { useQuery } from "@tanstack/react-query";

export type TEnumName = valueOf<
  [
    "EInformationType",
    "EEmploymentStatus",
    "EDocumentStatus",
    "EQuarter",
    "EGender",
    "ERecruitmentStatus",
    "EEmailDelivery",
    "EMatchContractStatus",
    "EJobStatus",
    "EJobTag",
    "EClientType",
    "EEmploymentType",
    "ESalaryType",
    "EYesNoPendingStatus",
    "EJapaneseLevelType",
    "ERecruitmentLocationType",
    "ESpecifiedSkillPassed",
    "EForeignLanguage",
    "EEducationLevel",
    "EPartnerContactMethod",
    "EJobCaseFilter",
    "EPlanStatus",
    "ECurriculumProgress",
    "ECompanyContractStatus",
    "EPartType",
    "EUserPermission",
    "EExamProcedureAgent",
  ]
>;

export const fetchEnumApi = async (enumName: TEnumName, req?: TGetEnumOptionReqDto): Promise<TGetEnumOptionsResDto> => {
  const url = createUrlWithParams(`/enums/${enumName}/options`, req);
  const rs = await globalApi.get<TGetEnumOptionsResDto>(url);
  return rs.data;
};

export const useEnum = (enumName?: TEnumName, req?: TGetEnumOptionReqDto) => {
  const { data, ...rest } = useQuery({
    queryKey: [QUERY_KEYS.GLOBAL.FETCH_ENUM, enumName, req?.lang],
    queryFn: () => (enumName ? fetchEnumApi(enumName, req) : undefined),
    enabled: Boolean(enumName),
    staleTime: CACHED_TIME,
    gcTime: CACHED_TIME,
  });

  return { data: data?.data ?? [], ...rest };
};
